import type { Level1To10 } from "../shared/game-types";

/** One in-game year is deliberately short enough to see, but long enough for twice-daily check-ins. */
export const DEFAULT_SECONDS_PER_GAME_YEAR = 1_800;

/** L1 is granted at world creation; the first actionable L2 project takes 30 real minutes. */
export const RESEARCH_DURATION_YEARS: Readonly<Record<Level1To10, number>> = {
  1: 1,
  2: 1,
  3: 4,
  4: 12,
  5: 24,
  6: 32,
  7: 40,
  8: 44,
  9: 46,
  10: 48,
};

export const INITIAL_RESEARCH_CAPACITY = 4_000;
export const RESEARCH_CAPACITY_PER_INDUSTRY_LEVEL = 200;

/** Target development level -> base upgrade years before the environment multiplier. */
export const DEVELOPMENT_UPGRADE_YEARS: readonly number[] = [0, 1, 3, 8, 16, 32, 48];

/** Fraction of light speed unlocked by each navigation capability level. */
export const NAVIGATION_CRUISE_SPEED_C: readonly number[] = [0.00008, 0.0003, 0.001, 0.015, 0.05, 0.1, 0.2, 0.5, 0.9, 0.995];
